<template>
  <div id = "OwnedEquipmentReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <div class="page-title">Owned Equipment Current Values</div>
            <div class="web-action-btn btn-groups text-right">
                <!-- Button for Clear Cache
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
        </div>
        <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'ownedEquipment'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
               <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'ownedEquipment'" :position="'top'">
                    </custom-pagination>
                    <!-- <vue-good-table
                        mode="remote"
                        title="ownedEquipment"
                        ref="ownedEquipment"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-select-all="onSelectAll"
                        @on-selected-rows-change="selectionChanged"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: perPage,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                        :select-options="{
                            enabled: false,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        :search-options="{
                        enabled: false,
                        }"

                        >
                    </vue-good-table> -->
                    <div class="vgt-responsive">
                        <v-table :data="rows" :class="'vgt-table bordered'" :hideSortIcons="true">
                            <thead slot="head">
                                <template v-for="(col,ind) in userColumns">
                                    <template v-if="col.sortable == false">
                                        <th :key="'col_'+ind" :id="col.field" v-show="!col.hidden">{{ col.label }}</th>
                                    </template>
                                    <template v-else>
                                        <th :key="'col_'+ind" :id="col.field" class="sorting" @click="onSortChangeReports($event)" v-show="!col.hidden">{{ col.label }}</th>
                                    </template>
                                </template>
                            </thead>
                            <tbody slot="body" slot-scope="{displayData}">
                                <tr v-for="row in displayData">
                                    <template v-for="(col,ind1) in userColumns">
                                        <td :key="ind1" v-show="!col.hidden">{{ row[col.field] }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </v-table>
                    </div>
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                    </custom-pagination>
                </section>
               </div>
            </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// 
// 
// 

import SmartTable from 'vuejs-smart-table'
Vue.use(SmartTable)

 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {

  name: "OwnedEquipmentReport",
  metaInfo() {
            return {title: "Owned Equipment Current Values Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px'
      },
      {
          label: 'Description',
          field: 'name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px'
      },
      {
          label: 'Serial Number',
          field: 'vin',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px'
      },
      {
          label: 'FEATURES',
          field: 'features',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false,
      },
      {
          label: 'Current NBV',
          field: 'net_book_value',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type: 'number'
      },
      {
          label: 'Contract End Date',
          field: 'contract_end_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false
      },
      {
          label: 'NBV Contract End',
          field: 'nbv_end',
          filterable: false,
          fpFieldType:"integer",
          type: 'number',
          hidden:false,
          sortable:false
      },
      {
          label: 'Residual',
          field: 'residual',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true
      },
      {
          label: 'Monthly Depr',
          field: 'monthly_dep',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type: 'number'
      },
      {
          label: 'Current Note Balance',
          field: 'current_note_bal',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type: 'number',
      },
      {
          label: 'Unit Note Balance',
          field: 'unit_note_bal',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type: 'number',
      },
      {
          label: 'LTD Mileage',
          field: 'ltd_mileage',
          filterable: true,
          fpFieldType:"integer",
          type: 'number',
          hidden:false
      },
      {
          label: 'UOM',
          field: 'uom',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          sortable:false
      },
      {
          label: 'Last Reading Date',
          field: 'reading_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false
      },
      {
          label: 'Purchase Date',
          field: 'purchase_date',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false
      },
      {
          label: 'In Service Date',
          field: 'date_in_service',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false
      },
      {
          label: 'Agreement Type',
          field: 'agreement_type',
          hidden:false,
          filterable: true,
          sortable: false,
          fpFieldType:"option",
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['RC','LC'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Contract Type',
          field: 'conType',
          hidden:false,
          filterable: true,
          sortable: false,
          fpFieldType:"option"
      },
      {
          label: 'Agreement Number',
          field: 'agreement_no',
          sortable: false,
          hidden:false,
          filterable: true,
          fpFieldType:"text"
      },
      {
          label: 'Schedule A',
          field: 'sch_a',
          sortable: false,
          hidden:false,
          filterable: false,
          fpFieldType:"text"
      },
      {
          label: 'Facility',
          field: 'location',
          fpFieldType:"option",
          hidden:false,
          filterable: true
      },
      {
          label: 'Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option"
      },
      {
          label: 'Customer',
          field: 'customer',
          hidden:false,
          filterable: true,
          //sortable: false,
          fpFieldType:"text"
      },
      {
          label: 'Customer Number',
          field: 'customer_no',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
          //sortable: false,
      },
      {
          label: 'Equipment Type',
          field: 'equip_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option"
      },
      {
          label: 'Equipment Group',
          field: 'equip_grp',
          hidden:false,
          filterable: true,
          fpFieldType:"text"
      },
      {
          label: 'Year',
          field: 'year',
          hidden:false,
          filterable: true,
          fpFieldType:"text"
      },
      {
          label: 'Model',
          field: 'model',
          hidden:false,
          filterable: true,
          fpFieldType:"text"
      },
      {
          label: 'Mfg',
          field: 'manufacturer_code',
          hidden:false,
          filterable: true,
          fpFieldType:"text"
      },
      {
          label: 'Financier',
          field: 'fin_code',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Description',
          field: 'fin_name',
          sortable: false,
          hidden:false,
          filterable: false,
          fpFieldType:"text"
      },
      {
          label: 'Note Ref',
          field: 'note',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Available for Sale',
          field: 'available_for_sale',
          filterable: true,
          fpFieldType:"custom_date",
          hidden:false
      },
      {
          label: 'List Price',
          field: 'list_price',
          filterable: true,
          fpFieldType:"integer",
          hidden:false,
          type: 'number'
      },
      {
          label: 'Permit Type',
          field: 'permit_type',
          hidden:false,
          fpFieldType:"text",
          filterable: true
      },
      {
          label: 'Plate Type',
          field: 'license_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['Full Plated(F)','Prorate(P)'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Permit Seq',
          field: 'permit_seq',
          // sortable: false,
          hidden:false,
          filterable: true,
          fpFieldType:"text"
      },
      {
          label: 'Permit Number',
          field: 'permit_number',
          hidden:false,
          fpFieldType:"text",
          filterable: true
      },
      {
          label: 'Permit Description',
          field: 'description',
          hidden:false,
          fpFieldType:"text",
          filterable: true
      },
      {
          label: 'State',
          field: 'state',
          hidden:false,
          fpFieldType:"text",
          filterable: true
      },
      {
          label: 'Effective Date',
          field: 'effective_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true
      },
      {
          label: 'Expiry Date',
          field: 'expiry_date',
          fpFieldType:"custom_date",
          hidden:false,
          filterable: true
      },
      {
          label: 'Owner',
          field: 'ownership',
          fpFieldType:"option",
          hidden: false,
          filterable: true
      },
      {
          label: 'Fleet Code',
          field: 'fleet_code',
          fpFieldType:"text",
          hidden: false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Permit Amt',
          field: 'amount',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true
      },
      {
          label: 'Billback Amt',
          field: 'billback_amount',
          hidden:false,
          type:'number',
          fpFieldType:"integer",
          filterable: true
      },
      {
          label: 'GVW',
          field: 'gross_weight',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true
      },
      {
          label: 'UOM',
          field: 'gvw_uom',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Last Posted Interest Amt',
          field: 'interest_amt',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: false,
          sortable:false,
      },
      {
          label: 'Depr Months Remaining',
          field: 'dep_months_remain',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Capital Cost',
          field: 'capital',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true
      },
      {
          label: 'Parking Location Code',
          field: 'parking_code',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Driver Code',
          field: 'driver_code',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Supervisor Driver Code',
          field: 'super_driver_code',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'User Status Code',
          field: 'user_sts_code',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Equipment Type Description',
          field: 'equip_type_desc',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Super Type',
          field: 'super_type',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Super Type Description',
          field: 'super_type_desc',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Facility Description',
          field: 'location_desc',
          fpFieldType:"text",
          hidden:false,
          filterable: true
      },
      {
          label: 'Note Payout Date',
          field: 'note_pay_date',
          fpFieldType:"date",
          hidden:false,
          filterable: false,
           sortable:false,
      },
      {
          label: 'Transmission Make',
          field: 'trans_manufacturer',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Transmission Model',
          field: 'trans_model',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Engine Make',
          field: 'engine_manufacturer',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Engine Model',
          field: 'engine_model',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Body Make',
          field: 'body_manufacturer',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Body Model',
          field: 'body_style',
          fpFieldType:"text",
          hidden: false,
          filterable: true
      },
      {
          label: 'Months In Service',
          field: 'months_in_service',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Pool Start Date',
          field: 'pool_start_date',
          fpFieldType:"custom_date",
          hidden:false,
          filterable: true
      },
      {
          label: 'Days in Pool',
          field: 'days_in_pool',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false
      },
      {
          label: 'WO Costs in Pool',
          field: 'wo_cost_pool',
          fpFieldType:"text",
          hidden:false,
          type:'number',
          filterable: false,
          sortable:false,
      },
      {
          label: 'Equip Comments',
          field: 'equip_comments',
          fpFieldType:"text",
          hidden: false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'NBV Plus WO Costs',
          field: 'nbv_wo_cost',
          fpFieldType:"text",
          hidden:false,
          type:'number',
          filterable: false,
          sortable:false,
      },
      {
          label: 'Final Debt Unit Payout Amt',
          field: 'debt_unit_amt',
          fpFieldType:"text",
          hidden:false,
          type:'number',
          filterable: false,
          sortable:false,
      },

    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'owned_equipment_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.ownedEquipment.unselectAllInternal();
    },
    loadList(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
    //   var data = this.$refs['ownedEquipment'].selectedRows;
    //   for ( var i = 0; i < data.length; i++ ) {
    //       selectedRows.push(this.$refs['ownedEquipment'].selectedRows[i].id)
    //   }

      $.ajax({
        url: process.env.ROOT_API + "/owned-equipment-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          sort: self.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'owned-equipment-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/OwnedEquipmentReport.vue